module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface#ch01"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgments#ch02"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01#ch03"
    }
  }, [_c('b', [_vm._v("1"), _c('br'), _vm._v("An Alternative Theory of Urban Politics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch04"
    }
  }, [_vm._v("1 City Limits and the Study of Urban Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch05"
    }
  }, [_vm._v("2 The Interests of the Limited City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part02#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2"), _c('br'), _vm._v("City Limits and Public Policy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Three Policy Arenas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Toward a New Theory of Federalism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Cities, Suburbs, and Their Schools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c010"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Part03#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3"), _c('br'), _vm._v("City Limits and Urban Politics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Parties and Groups in Local Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The Politics of Development")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Politics of Allocation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Politics of Redistribution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part04#ch015",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4"), _c('br'), _vm._v("Changing the Limits on Urban Policy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Is New York a Deviant Case?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Redistribution in the Federal System")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "c018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix#ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix"), _c('br'), _vm._v("Determinants of Local Expenditures, a Review of the Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/References#ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index#ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772d7f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 66
// module chunks = 0